import { PageHeader } from "@positive/ui";
import { MessageStrip } from "@ui5/webcomponents-react";
import { useTranslation } from "react-i18next";

/**
 * Shown instead of a route the user may not open (deny by default). The API enforces the same keys. When the route's
 * plan module is not in the tenant's subscription, no permission opens it and only the platform operator can add the
 * module, so the page says that instead of "ask your administrator" (SRV-J-02).
 */
export function ForbiddenPage({ module }: { module?: string }) {
  const { t } = useTranslation("shell");
  const { t: tp } = useTranslation("platform");
  if (module !== undefined) {
    const name = tp(`modules.${module}`, { defaultValue: module });
    return (
      <section
        className="page-section page-section-status"
        data-testid="forbidden"
        data-reason="module"
        data-module={module}
      >
        <PageHeader title={t("forbidden.moduleTitle", { module: name })} />
        <MessageStrip design="Information" hideCloseButton data-testid="forbidden-module">
          {t("forbidden.moduleMessage", { module: name })}
        </MessageStrip>
      </section>
    );
  }
  return (
    <section className="page-section page-section-status" data-testid="forbidden" data-reason="permission">
      <PageHeader title={t("forbidden.title")} />
      <MessageStrip design="Critical" hideCloseButton>
        {t("forbidden.message")}
      </MessageStrip>
    </section>
  );
}
